import { request } from '../../helpers/apiHelper'
import { displayNotification } from '../../actions/notificationsActions'
import { loanQuery, updateLoanMutation } from './queries'
import { Loan } from './types'

export enum LoanActionType {
  FETCH_ADVERSE_ACTION_REASONS_SUCCESS = 'FETCH_ADVERSE_ACTION_REASONS_SUCCESS',
  FETCH_LOAN_FAILURE = 'FETCH_LOAN_FAILURE',
  FETCH_LOAN_SUCCESS = 'FETCH_LOAN_SUCCESS',
  UPDATE_LOAN_FAILURE = 'UPDATE_LOAN_FAILURE',
  UPDATE_LOAN_SUCCESS = 'UPDATE_LOAN_SUCCESS',
}

export interface LoanAction {
  type: LoanActionType
  entity?: any // TODO
  entities?: any // TODO
}

export const fetchLoan = (id?: string) => (dispatch) => {
  if (!id) return null

  return request(loanQuery.default, { id })
    .then((response) => {
      const { loan, adverseActionReasons } = response.data.data
      const adverseActionReasonEnumValues = adverseActionReasons.enumValues

      dispatch({
        type: LoanActionType.FETCH_LOAN_SUCCESS,
        entity: loan,
      })
      dispatch({
        type: LoanActionType.FETCH_ADVERSE_ACTION_REASONS_SUCCESS,
        entities: adverseActionReasonEnumValues,
      })
    })
    .catch(() => {
      dispatch({
        type: LoanActionType.FETCH_LOAN_FAILURE,
      })
      dispatch(displayNotification('Failed to fetch Loan', 'error'))
    })
}

export const updateLoan = (loan: Loan, params) => (dispatch) => {
  const { id } = loan
  return request(updateLoanMutation.default, { ...params, id })
    .then((response) => {
      dispatch({
        type: LoanActionType.UPDATE_LOAN_SUCCESS,
        entity: response.data.data.loan,
      })
    })
    .catch(() => {
      dispatch({
        type: LoanActionType.UPDATE_LOAN_FAILURE,
        entity: loan,
      })
      dispatch(displayNotification('Failed to update Loan', 'error'))
    })
}
